/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import React from 'react'
import { Navigate } from 'react-router-dom'

import useLoggedInUser from '@/hooks/useLoggedInUser'

function SingleStoreGuard({ children }: { children?: React.ReactNode }) {
  const { user } = useLoggedInUser('cache-first')
  const storeIds = user?.stores.map(store => store.id)
  const hasMultipleStores = user?.hasMultipleStores
  const path = window.location.pathname
  // Routes that don't need redirection even for single-store users
  const excludedRoutes = ['/admin', '/stores', '/tasks']
  const shouldRedirect =
    !excludedRoutes.some(route => path.startsWith(route)) &&
    !path.includes('stores')

  if (
    storeIds &&
    storeIds.length === 1 &&
    shouldRedirect &&
    !hasMultipleStores
  ) {
    // TODO: how do we know we are on a route that is fine for a single store???
    return (
      <Navigate
        to={`/stores/${storeIds[0]}`}
        state={{ from: location.pathname }}
        replace
      />
    )
  }

  return <>{children}</>
}

export default SingleStoreGuard
